import { useEffect, useState } from "react";

export type BeforeAfterPair = {
    pair_id: string;
    before: { id: string; url: string | null; alt: string | null };
    after: { id: string; url: string | null; alt: string | null };
    project: { slug: string; title: string; location: string | null };
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL as string;

/**
 * Fetch Vorher/Nachher-Paare aus Showcase-Projekten.
 * `source`: "main" (Startseite) oder "sylt" (Sylt-Seite).
 */
export function useBeforeAfterPairs(source: "main" | "sylt"): {
    items: BeforeAfterPair[];
    loading: boolean;
} {
    const [items, setItems] = useState<BeforeAfterPair[]>([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        let cancelled = false;
        void (async () => {
            try {
                const res = await fetch(`${BACKEND_URL}/api/pairs/${source}`, {
                    credentials: "omit",
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (!cancelled) {
                    const raw = (data.items || []) as BeforeAfterPair[];
                    // Nur Paare mit beiden URLs anzeigen
                    setItems(raw.filter((p) => p.before?.url && p.after?.url));
                }
            } catch {
                if (!cancelled) setItems([]);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => { cancelled = true; };
    }, [source]);
    return { items, loading };
}
